module.exports = __webpack_public_path__ + "static/media/signed-copy-icon.9b4eb0a6.svg";